import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import BreadcrumbSeven from "../components/BreadcrumbSeven";
import Blog from "../components/Blog";
import BrandSectionOne from "../components/BrandSectionOne";
import Preloader from "../helper/Preloader";
const BlogPage = () => {
  const { i18n, t } = useTranslation();
  const { pathname } = useLocation();
  const siteUrl = (process.env.REACT_APP_PAGE_WEBSITE_URL || "").replace(/\/$/, "");
  const canonicalUrl = siteUrl ? `${siteUrl}${pathname}` : pathname;
  const title = `Nomio Blog | ${t("blog")}`;
  const description = t("blogPage.title");
  const shareImage = siteUrl ? `${siteUrl}/assets/images/logo/logo.png` : "";

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonicalUrl} />

        <meta property="og:locale" content={i18n.language} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonicalUrl} />
        {shareImage && <meta property="og:image" content={shareImage} />}

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        {shareImage && <meta name="twitter:image" content={shareImage} />}
      </Helmet>

      {/* Preloader */}
      <Preloader />

      {/* BreadcrumbSeven */}
      <BreadcrumbSeven />

      {/* Blog */}
      <Blog />

      {/* BrandSectionOne */}
      <BrandSectionOne />

    </>
  );
};

export default BlogPage;
